<div class="game" (click)="toggleOverlay()">
  @if (!isModal()) {
    <ng-container *ngTemplateOutlet="isTournamentPreview() ? tournamentPreviewBadges : normalGameBadges"></ng-container>
  }

  <img
    defaultImage
    ImgDimension
    [width]="178"
    [height]="231"
    loading="lazy"
    class="game__image"
    [ngClass]="{ loaded: isModal() }"
    [alternative]="game['bgSrc']"
    [attr.src]="isModal() ? game['imgSrc'] : null"
    [attr.data-src]="!isModal() ? game['imgSrc'] : null"
    [alt]="game.name || ''"
    ClassLoaded
  />

  <div class="game__overlay" [ngClass]="{ 'overlay-visible': isShowOverlay() }" (click)="openGame(); $event.stopPropagation()">
    <i
      class="game__favorite"
      [ngClass]="{
        'icon-like': !game.favorite,
        'icon-like_filled': game.favorite,
        'overlay-visible': isShowOverlay(),
      }"
      (click)="onFavoriteClick(game); $event.stopPropagation()"
    ></i>

    <div class="game__overlay--content">
      <a class="game__link" [href]="'/' + 'play/' + game?.slug | safe: 'url'" (click)="$event.preventDefault()">
        <i class="game__play icon-play"></i>
      </a>
      <span class="game__title">{{ game?.name }}</span>
      <span class="game__provider">{{ game?.provider?.name }}</span>
    </div>
  </div>
</div>

@if (isModal() && game?.firstLabel && game?.secondLabel) {
  <div class="modal-info">
    <div class="modal-info--label first">{{ game?.firstLabel | translate }}</div>
    <div class="modal-info--label second">{{ game?.secondLabel | translate }}</div>
  </div>
}

<ng-template #normalGameBadges>
  @if (game.drops) {
    <img ImgDimension class="game__badge game__badge--drops" src="/assets/img/drops.png" alt="Daily drops" />
  }
  <div class="game__badges" [ngClass]="{ mystery: game?.mystery, fs: game?.freespins }">
    @if (game?.freespins) {
      <img ImgDimension class="freespins" src="/assets/img/badges/freespins.png" alt="freespins" />
    }
    @if (game.new) {
      <img ImgDimension src="/assets/svg/badges/new.svg" alt="New" />
    }
    @if (game.popular && !game.new) {
      <img ImgDimension src="/assets/svg/badges/hot.svg" alt="Hot" />
    }
    @if (game.prerelease) {
      <img ImgDimension class="exclusive" src="/assets/img/exclusive.png" alt="Exclusive" />
    }
    @if (
      game.jackpot &&
      jackpot.isJackpotEnable &&
      !(
        (user.auth && game.externalData.real[user.currentCurrency?.currency]?.jackpot) ||
        (!user.auth && (game.externalData.real[env.env.currency.short] || game.externalData.real['EUR'])?.jackpot)
      )
    ) {
      <img ImgDimension class="jackpot" src="/assets/svg/badges/jackpot.svg" alt="Jackpot" />
    }
    @if (game?.mystery) {
      <img ImgDimension class="mystery-drop" src="/assets/img/badges/mystery-drop.png" alt="mystery drop" />
    }
    @if (
      (user.auth && game.externalData.real[user.currentCurrency?.currency]?.jackpot) ||
      (!user.auth && (game.externalData.real[env.env.currency.short] || game.externalData.real['EUR'])?.jackpot)
    ) {
      <app-jackpot-badge [game]="game"></app-jackpot-badge>
    }
  </div>
</ng-template>

<ng-template #tournamentPreviewBadges>
  @if (tournamentBadge === 'drops') {
    <img ImgDimension class="game__badge game__badge--drops" src="/assets/img/drops.png" alt="Daily drops" />
  }
  <div class="game__badges">
    @switch (tournamentBadge) {
      @case ('freespins') {
        <img ImgDimension class="freespins" src="/assets/img/badges/freespins.png" alt="freespins" />
      }
      @case ('new') {
        <img ImgDimension src="/assets/svg/badges/new.svg" alt="New" />
      }
      @case ('popular') {
        <img ImgDimension src="/assets/svg/badges/hot.svg" alt="Hot" />
      }
      @case ('exclusive') {
        <img ImgDimension class="exclusive" src="/assets/img/exclusive.png" alt="Exclusive" />
      }
      @case ('jackpot') {
        <img ImgDimension class="jackpot" src="/assets/svg/badges/jackpot.svg" alt="Jackpot" />
      }
      @case ('mystery') {
        <img ImgDimension class="mystery-drop" src="/assets/img/badges/mystery-drop.png" alt="mystery drop" />
      }
      @case ('jackpotBadge') {
        <app-jackpot-badge [game]="game"></app-jackpot-badge>
      }
    }
  </div>
</ng-template>
